<script>
import { mapActions } from "vuex";

export default {
	name: "serverMetaData",
	props: {
		domain: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			metaData: {}
		};
	},
	methods: {
		...mapActions("request", ["fetchMeta"])
	},
	mounted() {
		this.fetchMeta(this.domain)
			.then(res => this.metaData = res.meta);
	}
};
</script>

<template>
	<v-row>
		<v-col v-if="metaData.customerContact" md="6" cols="12">
			<v-card>
				<v-card-title>
					Customer contact
				</v-card-title>
				<v-card-text>
					<v-list>
						<v-list-item v-if="metaData.customerContact.firstName || metaData.customerContact.surName">
							<v-icon>mdi-account</v-icon>
							{{ metaData.customerContact.firstName }} {{ metaData.customerContact.surName }}
						</v-list-item>
						<v-list-item v-if="metaData.customerContact.email">
							<v-icon>mdi-email</v-icon>
							<a :href="'tel:' + metaData.customerContact.email">
								{{ metaData.customerContact.email }}
							</a>
						</v-list-item>
						<v-list-item v-if="metaData.customerContact.phone">
							<v-icon>mdi-phone</v-icon>
							<a :href="'tel:' + metaData.customerContact.phone">
								{{ metaData.customerContact.phone }}
							</a>
						</v-list-item>
					</v-list>
				</v-card-text>
			</v-card>
		</v-col>
		<v-col :md="!metaData.customerContact ? '12' : '6'" cols="12">
			<v-card>
				<v-card-title>Meta Data</v-card-title>
				<v-card-text>
					<v-list>
						<v-list-item>Mode: {{ metaData.mode }}</v-list-item>
						<v-list-item>Acceptable Downtime: {{ metaData.acceptableDowntime }}</v-list-item>
						<v-list-item>Selected Contact: {{ metaData.selectedContact }}</v-list-item>
					</v-list>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>

</template>

<style lang="scss" scoped>
.v-card {
	height: 100%;
	.v-card__title {
		padding-bottom: 0;
	}
}
a {
	text-decoration: none;
	color: inherit;
}
.v-list-item {
	min-height: 30px;
	padding: 0;
}
.v-icon {
	padding-right: 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/elements/ServerMetaData.vue